const productTile = () => {
    const productTiles = document.querySelectorAll('[data-product-tile]');
    productTiles.forEach((tile) => {
        const video = tile.querySelector('.image__hover video');
        if (video) {
            video.pause();
            tile.addEventListener('mouseover', () => {
                video.play();
            });
            tile.addEventListener('mouseout', () => {
                video.pause();
            });
        }
    });
};
export { productTile };
